import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "./CommonValidations";

import LoadingOverlay from "./LoadingOverlay";
export default class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      industries: [],
      employees: [],
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.company_Id,
          sortable: true,
          cell: (row) => <span>{row.company_Id}</span>,
        },
        {
          name: "Company Name",
          selector: (row, i) => row.companyName,
          sortable: true,
          cell: (row) => <span>{row.companyName}</span>,
        },
        {
          name: "Company Id",
          selector: (row, i) => row.companyId,
          sortable: true,
          cell: (row) => <span>{row.companyId}</span>,
        },
        {
          name: "Company Address",
          selector: (row, i) => row.companyAddress,
          sortable: true,
          cell: (row) => <span>{row.companyAddress}</span>,
        },
        {
          name: "GSTIN",
          selector: (row, i) => row.gstin,
          sortable: true,
          cell: (row) => <span>{row.gstin}</span>,
        },
        {
          name: "Pan",
          selector: (row, i) => row.pan,
          sortable: true,
          cell: (row) => <span>{row.pan}</span>,
        },
        {
          name: "Company OwnerId",
          selector: (row, i) => row.companyownerId,
          sortable: true,
          cell: (row) => <span>{row.companyownerId}</span>,
        },
        {
          name: "Logo",
          selector: (row, i) => row.logo,
          sortable: true,
          cell: (row) => <span>{row.logo}</span>,
        },
        {
          name: "Industry",
          selector: (row, i) => row.industry,
          sortable: true,
          cell: (row) => <span>{row.industry}</span>,
        },
        {
          name: "Company Size",
          selector: (row, i) => row.companySize,
          sortable: true,
          cell: (row) => <span>{row.companySize}</span>,
        },
        {
          name: "Company Email",
          selector: (row, i) => row.companyEmail,
          sortable: true,
          cell: (row) => <span>{row.companyEmail}</span>,
        },
        {
          name: "Company Website",
          selector: (row, i) => row.companyWebsite,
          sortable: true,
          cell: (row) => <span>{row.companyWebsite}</span>,
        },
        {
          name: "Primary Contact Ids",
          selector: (row, i) => row.primarycontactIds,
          sortable: true,
          cell: (row) => <span>{row.primarycontactIds}</span>,
        },
        {
          name: "Company Status reports",
          selector: (row, i) => row.companystatusReports,
          sortable: true,
          cell: (row) => <span>{row.companystatusReports}</span>,
        },
        {
          name: "Company Contact number",
          selector: (row, i) => row.companycontactNumber,
          sortable: true,
          cell: (row) => <span>{row.companycontactNumber}</span>,
        },
        {
          name: "Company Contact person",
          selector: (row, i) => row.companyContactperson,
          sortable: true,
          cell: (row) => <span>{row.companyContactperson}</span>,
        },
        {
          name: "Company Contact person Designation",
          selector: (row, i) => row.companycontactpersonDesignation,
          sortable: true,
          cell: (row) => <span>{row.companycontactpersonDesignation}</span>,
        },
        {
          name: "Company Type ",
          selector: (row, i) => row.companyType,
          sortable: true,
          cell: (row) => <span>{row.companyType}</span>,
        },
        {
          name: "Color Code",
          selector: (row, i) => row.colourCode,
          sortable: true,
          cell: (row) => <span>{row.colourCode}</span>,
        },
        {
          name: "Company contract Status",
          selector: (row, i) => row.companycontractStatus,
          sortable: true,
          cell: (row) => <span>{row.companycontractStatus}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={() => this.CompanyeditHandler(row)}
                className="bi bi-pen"
                style={{ marginRight: "3px" }}
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      companyName: "",
      companyid: "",
      colourCode: "",
      companyAddress: "",
      gstin: "",
      pan: "",
      companyownerId: "",
      logo: null,
      industry: "",
      companySize: "",
      companyEmail: "",
      companyWebsite: "",
      primarycontactIds: "",
      companystatusReports: "",
      companycontactNumber: "",
      companyContactperson: "",
      companycontactpersonDesignation: "",
      companyType: "",
      companycontractStatus: "",
      isEdit: false,
      editId: null,
      validationErrors: {},
      companyTypes: [],
      employees_Id: "",
      cName: "",
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      // companyName: "",
      // companyid: "",
      // colourCode:"",
      // companyAddress: "",
      // gstin: "",
      // pan: "",
      // companyownerId: "",
      // logo: null,
      // industry: "",
      // companySize: "",
      // companyEmail: "",
      // companyWebsite: "",
      // primarycontactIds: "",
      // companystatusReports: "",
      // companycontactNumber: "",
      // companyContactperson: "",
      // companycontactpersonDesignation: "",
      // companyType: "",
      // companycontractStatus: "",
      // isEdit: false,
      // editId: null,
      // validationErrors: {},
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  // Validation methods
  validateField = (fieldName, value) => {
    let validation = { isValid: true, message: "" };

    switch (fieldName) {
      case "companyEmail":
        if (value) {
          validation = ValidationUtils.validateEmail(value);
        }
        break;
      case "pan":
        if (value) {
          validation = ValidationUtils.validateCompanyPAN(value);
        }
        break;
      case "companycontactNumber":
        if (value) {
          validation = ValidationUtils.validatePhone(value);
        }
        break;
      case "companyWebsite":
        if (
          value &&
          !value.match(
            /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/
          )
        ) {
          validation = {
            isValid: false,
            message: "Please enter a valid website URL",
          };
        }
        break;
      case "gstin":
        if (
          value &&
          !value.match(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
          )
        ) {
          validation = {
            isValid: false,
            message: "Please enter a valid GSTIN (e.g., 22AAAAA0000A1Z5)",
          };
        }
        break;
      default:
        break;
    }

    return validation;
  };

  validateForm = () => {
    const fields = [
      "companyName",
      "companyid",
      "companyEmail",
      "pan",
      "companycontactNumber",
    ];
    let isValid = true;
    let errors = {};

    // Required field validation
    fields.forEach((field) => {
      if (!this.state[field] || this.state[field].trim() === "") {
        errors[field] = `${field
          .replace(/([A-Z])/g, " $1")
          .trim()} is required`;
        isValid = false;
      }
    });

    // Specific field validations
    if (this.state.companyEmail) {
      const emailValidation = this.validateField(
        "companyEmail",
        this.state.companyEmail
      );
      if (!emailValidation.isValid) {
        errors.companyEmail = emailValidation.message;
        isValid = false;
      }
    }

    if (this.state.pan) {
      const panValidation = this.validateField("pan", this.state.pan);
      if (!panValidation.isValid) {
        errors.pan = panValidation.message;
        isValid = false;
      }
    }

    if (this.state.companycontactNumber) {
      const phoneValidation = this.validateField(
        "companycontactNumber",
        this.state.companycontactNumber
      );
      if (!phoneValidation.isValid) {
        errors.companycontactNumber = phoneValidation.message;
        isValid = false;
      }
    }

    if (this.state.gstin) {
      const gstinValidation = this.validateField("gstin", this.state.gstin);
      if (!gstinValidation.isValid) {
        errors.gstin = gstinValidation.message;
        isValid = false;
      }
    }

    if (this.state.companyWebsite) {
      const websiteValidation = this.validateField(
        "companyWebsite",
        this.state.companyWebsite
      );
      if (!websiteValidation.isValid) {
        errors.companyWebsite = websiteValidation.message;
        isValid = false;
      }
    }

    this.setState({ errors });
    return isValid;
  };

  CompanyeditHandler = (row) => {
    this.setState({
      companyName: row.companyName || "",
      companyid: row.companyId || "",
      companyAddress: row.companyAddress || "",
      gstin: row.gstin || "",
      pan: row.pan || "",
      companyownerId: row.companyownerId || "",
      logo: row.logo || "",
      industry: row.industry || "",
      companySize: row.companySize || "",
      companyEmail: row.companyEmail || "",
      companyWebsite: row.companyWebsite || "",
      primarycontactIds: row.primarycontactIds || "",
      companystatusReports: row.companystatusReports || "",
      companycontactNumber: row.companycontactNumber || "",
      companyContactperson: row.companyContactperson || "",
      companycontactpersonDesignation:
        row.companycontactpersonDesignation || "",
      companyType: row.companyType || "",
      companycontractStatus: row.companycontractStatus || "",
      colourCode: row.colourCode || "",
      isEdit: true,
      editId: row.company_Id,
      show: true,
      validationErrors: {},
    });
  };
  IndustrytypemasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Industrytypemaster/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ industries: data.list });
        }
      });
  };
  EmployeesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  CompanyfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Company/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  CompanysubmitHandler = (e) => {
    e.preventDefault();

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyName", this.state.companyName);
    formData.append("companyid", this.state.companyid);
    formData.append("companyAddress", this.state.companyAddress);
    formData.append("gstin", this.state.gstin);
    formData.append("pan", this.state.pan);
    formData.append("companyownerId", this.state.companyownerId);
    formData.append("colourCode", this.state.colourCode);
    // Handle file upload properly
    if (this.state.logo instanceof File) {
      formData.append("logo", this.state.logo);
    } else if (this.state.logo && typeof this.state.logo === "string") {
      // For edit mode, if logo is a string (existing path), don't append it
      // The backend will handle keeping the existing logo
    }
    formData.append("industry", this.state.industry);
    formData.append("companySize", this.state.companySize);
    formData.append("companyEmail", this.state.companyEmail);
    formData.append("companyWebsite", this.state.companyWebsite);
    formData.append("primarycontactIds", this.state.primarycontactIds);
    formData.append("companystatusReports", this.state.companystatusReports);
    formData.append("companycontactNumber", this.state.companycontactNumber);
    formData.append("companyContactperson", this.state.companyContactperson);
    formData.append(
      "companycontactpersonDesignation",
      this.state.companycontactpersonDesignation
    );
    formData.append("companyType", this.state.companyType);
    formData.append("companycontractStatus", this.state.companycontractStatus);
    formData.append("cName", this.state.cName);
    const apiUrl = this.state.isEdit ? "C_Company/update" : "C_Company/add";
    if (this.state.isEdit) {
      formData.append("company_Id", this.state.editId);
    }

    fetch(configData.api_url + apiUrl, {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CompanyfetchHandler();
          this.handleOffcanvasClose();
        }
      });
  };
  // Deprecated - now using CompanysubmitHandler for both add and update
  CompanyupdateHandler = (e) => {
    // This method is deprecated - CompanysubmitHandler handles both add and update
    this.CompanysubmitHandler(e);
  };

  componentDidMount() {
    this.CompanyfetchHandler();
    this.fetchCompanyTypes();
    this.IndustrytypemasterfetchHandler();
    this.EmployeesfetchHandler();
  }

  fetchCompanyTypes = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Companytypemaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.list) {
          this.setState({ companyTypes: data.list });
        }
      })
      .catch((error) => {
        console.error("Error fetching company types:", error);
      });
  };
  // Generic field change handler with validation
  handleFieldChange = (fieldName, value) => {
    // Update state
    this.setState({ [fieldName]: value });

    // Validate field
    const validation = this.validateField(fieldName, value);
    const errors = { ...this.state.errors };

    if (!validation.isValid) {
      errors[fieldName] = validation.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
  };

  handlecompanyNameChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyName", e.target.value);
  };

  handlecompanyidChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyid", e.target.value);
  };

  handlecompanyAddressChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyAddress", e.target.value);
  };

  handlegstinChange = (e) => {
    e.preventDefault();
    const value = e.target.value.toUpperCase();
    this.handleFieldChange("gstin", value);
  };

  handlepanChange = (e) => {
    e.preventDefault();
    const value = e.target.value.toUpperCase();
    this.handleFieldChange("pan", value);
  };

  handlecompanyownerIdChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyownerId", e.target.value);
  };
  handlecolorCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ colourCode: fieldValue });
  };
  handlelogoUploadChange = (e) => {
    const file = e.target.files[0];
    this.setState({ logo: file });
  };

  handleindustryChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("industry", e.target.value);
  };

  handlecompanySizeChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companySize", e.target.value);
  };

  handlecompanyEmailChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyEmail", e.target.value);
  };

  handlecompanyWebsiteChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyWebsite", e.target.value);
  };

  handleprimarycontactIdsChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("primarycontactIds", e.target.value);
  };

  handlecompanystatusReportsChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companystatusReports", e.target.value);
  };

  handlecompanycontactNumberChange = (e) => {
    e.preventDefault();
    const value = e.target.value.replace(/\D/g, "");
    this.handleFieldChange("companycontactNumber", value);
  };

  handlecompanyContactpersonChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyContactperson", e.target.value);
  };

  handlecompanycontactpersonDesignationChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companycontactpersonDesignation", e.target.value);
  };

  handlecompanyTypeChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companyType", e.target.value);
  };

  handlecompanycontractStatusChange = (e) => {
    e.preventDefault();
    this.handleFieldChange("companycontractStatus", e.target.value);
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("company_Id", row.company_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Company/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CompanyfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Company
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            {this.state.isEdit ? "Edit Company" : "Add Company"}
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecompanyNameChange}
                                        className={`form-control ${this.state.errors.companyName
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="companyName"
                                        value={this.state.companyName}
                                        required="required"
                                        placeholder="Enter Company Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecompanyidChange}
                                        className={`form-control ${this.state.errors.companyid
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="companyid"
                                        value={this.state.companyid}
                                        required="required"
                                        placeholder="Enter Company ID"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyid}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Address
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecompanyAddressChange
                                        }
                                        className={`form-control ${this.state.errors.companyAddress
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="companyAddress"
                                        value={this.state.companyAddress}
                                        placeholder="Enter Company Address"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyAddress}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        GSTIN
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlegstinChange}
                                        className={`form-control ${this.state.errors.gstin
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="gstin"
                                        value={this.state.gstin}
                                        placeholder="Enter GSTIN (e.g., 22AAAAA0000A1Z5)"
                                        maxLength={15}
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.gstin}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Pan
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlepanChange}
                                        className={`form-control ${this.state.errors.pan
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="pan"
                                        value={this.state.pan}
                                        required="required"
                                        placeholder="Enter Company PAN (e.g., ABCCA1234B)"
                                        maxLength={10}
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.pan}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company OwnerId
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={
                                          this.handlecompanyownerIdChange
                                        }
                                        className="form-control"
                                        name="companyownerId"
                                        value={this.state.companyownerId}
                                      >
                                        <option>Select Owner</option>
                                        {this.state.employees.map(
                                          (api, index) => (
                                            <option
                                              key={index}
                                              value={api.employees_Id}
                                            >
                                              {`${api.fName} ${api.lName}`}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyownerId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Logo
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      {this.state.isEdit &&
                                        this.state.logo &&
                                        typeof this.state.logo === "string" && (
                                          <div style={{ marginBottom: "10px" }}>
                                            <img
                                              src={
                                                configData.api_url.replace(
                                                  "/index.php/",
                                                  "/"
                                                ) + this.state.logo
                                              }
                                              alt="Current Logo"
                                              style={{
                                                maxWidth: "100px",
                                                maxHeight: "100px",
                                                border: "1px solid #ccc",
                                              }}
                                            />
                                            <small
                                              style={{
                                                display: "block",
                                                color: "#666",
                                              }}
                                            >
                                              Current Logo
                                            </small>
                                          </div>
                                        )}
                                      <Form.Control
                                        type="file"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={this.handlelogoUploadChange}
                                        className="form-control"
                                        name="logo"
                                      //value={this.state.logo}
                                      />
                                      <small className="text-muted">
                                        {this.state.isEdit
                                          ? "Upload new logo to replace current one"
                                          : "Upload company logo (JPG, PNG, GIF - Max 5MB)"}
                                      </small>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Industry
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        className="form-select"
                                        onChange={this.handleindustryChange}
                                        name="industry"
                                        value={this.state.industry}
                                      >
                                        <option>Select Industry</option>
                                        {this.state.industries.map(
                                          (api, index) => (
                                            <option
                                              key={index}
                                              value={api.industrytypeamster_Id}
                                            >
                                              {api.industrytype}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Size
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecompanySizeChange}
                                        className="form-control"
                                        name="companySize"
                                        value={this.state.companySize}
                                        placeholder="Enter Company Size"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companySize}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Email
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="email"
                                        onChange={this.handlecompanyEmailChange}
                                        className={`form-control ${this.state.errors.companyEmail
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="companyEmail"
                                        value={this.state.companyEmail}
                                        required="required"
                                        placeholder="Enter Company Email"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyEmail}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Website
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="url"
                                        onChange={
                                          this.handlecompanyWebsiteChange
                                        }
                                        className={`form-control ${this.state.errors.companyWebsite
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="companyWebsite"
                                        value={this.state.companyWebsite}
                                        placeholder="Enter Company Website (e.g., https://example.com)"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyWebsite}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Primary Contact Ids
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleprimarycontactIdsChange
                                        }
                                        className="form-control"
                                        name="primarycontactIds"
                                        value={this.state.primarycontactIds}
                                        placeholder="Enter Primary Contact IDs"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.primarycontactIds}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Status reports
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecompanystatusReportsChange
                                        }
                                        className="form-control"
                                        name="companystatusReports"
                                        value={this.state.companystatusReports}
                                        placeholder="Enter Status Reports"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.companystatusReports
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Contact number
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="tel"
                                        onChange={
                                          this.handlecompanycontactNumberChange
                                        }
                                        className={`form-control ${this.state.errors.companycontactNumber
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        name="companycontactNumber"
                                        value={this.state.companycontactNumber}
                                        required="required"
                                        placeholder="Enter 10-digit Mobile Number"
                                        maxLength={10}
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.companycontactNumber
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Contact person
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecompanyContactpersonChange
                                        }
                                        className="form-control"
                                        name="companyContactperson"
                                        value={this.state.companyContactperson}
                                        placeholder="Enter Contact Person Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.companyContactperson
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Contact person Designation
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this
                                            .handlecompanycontactpersonDesignationChange
                                        }
                                        className="form-control"
                                        name="companycontactpersonDesignation"
                                        value={
                                          this.state
                                            .companycontactpersonDesignation
                                        }
                                        placeholder="Enter Contact Person Designation"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors
                                          .companycontactpersonDesignation
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Type{" "}
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handlecompanyTypeChange}
                                        className="form-control"
                                        name="companyType"
                                        value={this.state.companyType}
                                      >
                                        <option value="">
                                          Select Company Type
                                        </option>
                                        {this.state.companyTypes.map(
                                          (type, index) => (
                                            <option
                                              key={index}
                                              value={type.CompanyType}
                                            >
                                              {type.CompanyType}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyType}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="color"
                                        onChange={this.handlecolorCodeChange}
                                        className="form-control"
                                        name="colourCode"
                                        value={this.state.colourCode}
                                        required="required"
                                      //  placeholder="Enter Dummy One"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.colourCode}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company contract Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecompanycontractStatusChange
                                        }
                                        className="form-control"
                                        name="companycontractStatus"
                                        value={this.state.companycontractStatus}
                                        placeholder="Enter Contract Status"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.companycontractStatus
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.CompanysubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  {this.state.isEdit ? "Update" : "Save"}
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
